export default __webpack_public_path__ + "static/media/landing2.e239f781.png";